import $ from "jquery";

export function recaptchaTokenCreate ()
{
    grecaptcha.ready(function() {
        grecaptcha.execute('6LcsaOYUAAAAAF3nA4vJurjle31fHpH4lRv6l4FE', {action: 'homepage'}).then(function(token) {
                const recaptchaFields = document.querySelectorAll('.recaptchaResponse');
                recaptchaFields.forEach(field => field.value = token);
        });
    });
}

export function recaptchaTokenRefresh ()
{
    grecaptcha.ready(function () {
        grecaptcha.execute("6LcsaOYUAAAAAF3nA4vJurjle31fHpH4lRv6l4FE", {action: "request_call_back"}).then(function (token) {
            $(".recaptchaResponse").val(token);
        })
    });
}